/**
 * Workaround de l'optimisation que fait Vite sur les check de constante et de variables d'environnement
 * Vite optimise tous les if avec une comparaison de 2 constantes ex: import.meta.env.UNE_VAR === 'true'
 * Vite efface le code qui n'est jamais utilisé. Dans l'exemple précédent Vite va seulement garder le code du if (si true) ou du else (si false)
 */
export default function getRuntimeVariable<T = string>(variable: string): T {
  return JSON.parse(variable) as T
}
